<template>
  <div>
    <Hero
      >{{ $t('message.testDrive.personalInformationHeader')
      }}<img :src="require('@/assets/fa/waving-hand.svg')" width="22" height="22" class="ml-2" alt="" />
      <template slot="description">{{ $t('message.testDrive.personalInformationDescription') }}</template>
    </Hero>
    <PersonalInformationForm></PersonalInformationForm>
  </div>
</template>
<script>
import Hero from '@/components/test-drive/Hero.vue';
import PersonalInformationForm from '@/components/test-drive/PersonalInformationForm.vue';

export default {
  name: 'PersonalInformation',
  components: {
    Hero,
    PersonalInformationForm,
  },
};
</script>

<style lang="scss" scoped></style>
